import { css } from '@emotion/css';
import { ImageSchema,ImageSize } from 'Shared/model/basic';
import { useProxyProductionImages } from 'Shared/common/ProxyProductionImagesProvider';
import { useUrls } from 'Shared/UrlProvider';
import { Show } from 'solid-js';

const imageStyle = () => css({
	width: '100%',
	height: '100%',
	objectPosition: 'center',
	objectFit: 'cover'
});


interface ISuppliedPoster {
	image: ImageSchema,
	folder: string,
	size: ImageSize
}

export function SuppliedPoster(P: ISuppliedPoster)
{
	const imageUrl = () => 
		useUrls().createVenueImageUrl(P.image.hash,P.image,P.folder,P.size,useProxyProductionImages());

	return (
		<Show when={P.image?.hash}>
			<img class={imageStyle()} src={imageUrl()} />
		</Show>
	);
}

